export enum CertificateStatus {
    Valid = 'valid',
    Expired = 'expired',
    Revoked = 'revoked',
}